import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Subheading } from "capitalrx-components-2.0/lib/typography";
import styled from "styled-components";

import { ContentPanel, PageWrapper, ThemedButton } from "@/App/components";
import { useNavigateClient } from "@/App/hooks";
import { formatDMRConfirmationNumber } from "@/App/utils/directMemberReimbursement";

import SuccessCheckmark from "./success-checkmark.png";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementSuccessPage";

const SuccessIcon = styled.div`
  background-image: url(${SuccessCheckmark});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 40px;
  height: 40px;
`;

export const DirectMemberReimbursementSuccessPage = () => {
  const navigate = useNavigateClient();
  const { confirmationNumber } = useParams();
  const { t: translate } = useTranslation();

  const { isMobile } = useResponsive({
    isMobile: {
      mobile: true,
      tablet: false,
      desktop: false,
    },
  });

  const handleClickAnotherClaim = useCallback(() => {
    navigate(`/direct-member-reimbursement`);
  }, []);

  const handleClickGoHome = useCallback(() => {
    navigate(`/`);
  }, [navigate]);

  return (
    <PageWrapper>
      <ContentPanel>
        <Stack alignment="center" spacing="large">
          <Stack spacing="small" alignment="center">
            <SuccessIcon />
            <Heading>{translate(`${TRANSLATION_PATH}.claimSucceededHeading`)}</Heading>
          </Stack>
          <Stack alignment="center" spacing="small">
            <Body>{translate(`${TRANSLATION_PATH}.confirmationNumber`)}</Body>
            <Subheading>{formatDMRConfirmationNumber(confirmationNumber)}</Subheading>
          </Stack>
          <Body textAlign="center">{translate(`${TRANSLATION_PATH}.keepThisNumber`)}</Body>
          {isMobile ? (
            <Stack spacing="small" style={{ width: "100%" }}>
              <ThemedButton onClick={handleClickGoHome}>{translate(`${TRANSLATION_PATH}.home`)}</ThemedButton>
              <ThemedButton onClick={handleClickAnotherClaim} appearance="secondary">
                {translate(`${TRANSLATION_PATH}.anotherClaim`)}
              </ThemedButton>
            </Stack>
          ) : (
            <Shelf>
              <ThemedButton onClick={handleClickGoHome}>{translate(`${TRANSLATION_PATH}.home`)}</ThemedButton>
              <ThemedButton onClick={handleClickAnotherClaim} appearance="secondary">
                {translate(`${TRANSLATION_PATH}.anotherClaim`)}
              </ThemedButton>
            </Shelf>
          )}
        </Stack>
      </ContentPanel>
    </PageWrapper>
  );
};
